import React, { useCallback, useRef, } from "react";
import imagePlaceholder from "./ImagePlaceholder.svg";
import styles from "./Image.module.scss";
import cn from "classnames";
import Loader from "../Loader";
const Image = ({ className, imageClassName, fromFadeEffect = false, src, alt, onClick, onError, loading: htmlLoading, height, width, style, ...ariaAttributes }) => {
    let retryCount = 0;
    const [loading, setLoading] = React.useState(true);
    const ref = useRef(null);
    React.useEffect(() => {
        retryCount = 0;
        setUrl({ src: src });
    }, [src]);
    const setUrl = ({ src }) => {
        if (!isPrivateFile(src)) {
            if (ref.current) {
                ref.current.src =
                    typeof src === "string"
                        ? src
                        : src?.file.ownership_type === "PUBLIC"
                            ? src.file.download_url
                            : imagePlaceholder;
            }
        }
        else {
            setNewSignedUrl(src);
        }
    };
    const setNewSignedUrl = async ({ file, getSignedLink }) => {
        await getSignedLink(file.download_url)
            .then((url) => {
            if (ref.current && url) {
                ref.current.src = url;
            }
            retryCount = 0;
        })
            .catch((e) => {
            console.error(e);
            setLoading(false);
        });
    };
    const handleError = useCallback((e) => {
        retryCount++;
        if (isPrivateFile(src) && retryCount < 3) {
            setNewSignedUrl(src);
        }
        else {
            onError?.(e);
        }
    }, [src, setNewSignedUrl]);
    const Element = onClick != null ? "button" : "div";
    return (React.createElement(Wrapper, { className: cn("ukt-image", styles.image, loading && !fromFadeEffect && styles.loading, className), onClick: onClick, ...ariaAttributes },
        loading && fromFadeEffect && React.createElement(Loader, { className: "absolute" }),
        React.createElement("img", { onLoad: () => setLoading(false), onError: handleError, ref: ref, className: cn(fromFadeEffect && "invisible", !loading && fromFadeEffect && styles.fromFadeAnimation, imageClassName), alt: alt, loading: htmlLoading, height: height, width: width, style: style })));
};
const Wrapper = ({ onClick, children, ...rest }) => {
    if (onClick != null) {
        return (React.createElement("button", { onClick: onClick, ...rest }, children));
    }
    else {
        return React.createElement("div", { ...rest }, children);
    }
};
const isPrivateFile = (src) => {
    return (src != null &&
        typeof src !== "string" &&
        src.file.ownership_type !== "PUBLIC");
};
export default Image;
//# sourceMappingURL=Image.js.map